import { Component, Input } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { register } from 'swiper/element/bundle';
import { CommonModule } from '@angular/common';

register();

@Component({
  selector: 'app-carregando',
  templateUrl: './carregando.component.html',
  styleUrl: './carregando.component.css',
  standalone: false
})
export class CarregandoComponent {
  @Input() showCarregando = false;  
  @Input() isChart = true;
  @Input() containerHeight?: string;
  @Input() spinnerSize?: string;
}
